module.exports = __webpack_public_path__ + "static/services-image-3_m-d63d96df0df36d766a15e00011cd0c06.jpg";